export enum ToastViewportCssVars {
  /**
   * Indicates the height of the frontmost toast.
   * @type {number}
   */
  frontmostHeight = '--toast-frontmost-height',
}
